import { useState, useEffect } from "react";

const useTbdCheck = (formData, zone = null) => {
  const [tbdFields, setTbdFields] = useState({});
  const [hasTbd, setHasTbd] = useState(false);

  const checkForTBD = (data) => {
    const tbdFieldCheck = {};
    let containsTbd = false;

    Object.keys(data).forEach((key) => {
      const value = data[key];
      if (typeof value === "string" && value.toLowerCase().includes("tbd")) {
        tbdFieldCheck[key] = true;
        containsTbd = true;
      } else {
        tbdFieldCheck[key] = false;
      }
    });

    return { tbdFieldCheck, containsTbd };
  };

  useEffect(() => {
    if (formData) {
      const { tbdFieldCheck, containsTbd } = checkForTBD(formData);
      if (zone) {
        setTbdFields((prev) => ({
          ...prev,
          [zone]: tbdFieldCheck, // Use zone key if available
        }));
      } else {
        setTbdFields(tbdFieldCheck); // Directly store the field-check if no zones
      }
      setHasTbd(containsTbd); // Update the overall HasTBD status
    }
  }, [formData, zone]);

  return { tbdFields, hasTbd };
};

export default useTbdCheck;
